import GeneralImageAssetUploadJob from '@aytm/lib/AsyncJobManager/jobs/assets/ImageAssetUploadJob'
import AsyncJobManager from '@aytm/lib/AsyncJobManager/AsyncJobManager'

export const ImageAssetUploadManager = AsyncJobManager({ concurrency: 3 })

const config = {
  createAssetPath: null,
  templateID: null,
  srcSurveyID: null
}

export function configure({ createAssetPath, templateID, srcSurveyID } = {}) {
  config.createAssetPath = createAssetPath
  config.templateID = templateID
  config.srcSurveyID = srcSurveyID
}

export function ImageAssetUploadJob(file) {
  return config.createAssetPath
    ? GeneralImageAssetUploadJob({
        createAssetPath: config.createAssetPath,
        file,
        params: { template_id: config.templateID, src_survey_id: config.srcSurveyID }
      })
    : Promise.reject(new Error('ImageAssetUploadManager - createAssetPath not configured'))
}

export default function upload(droppedFiles, onProgress, withErrors) {
  const files = droppedFiles.slice(0, 100) // protect from mass upload
  return new Promise(resolve => {
    const uploadJobs = [...files].map(file => ImageAssetUploadJob(file))
    const fileTotalSizes = files.map(file => file.size || 0)
    const progress = {
      fileTotalSizes,
      fileLoadedSizes: Array.from({ length: files.length }),
      totalSize: fileTotalSizes.reduce((totalSize, fileSize) => totalSize + fileSize, 0),
      loadedSize: 0,
      totalFiles: files.length,
      loadedFiles: 0
    }
    ImageAssetUploadManager.queue(...uploadJobs).then(
      jobResults => {
        resolve(
          withErrors
            ? jobResults.map(result => (result.result?.status ? result.result : result))
            : jobResults.map(result => ('done' === result.status ? result.result : null)).filter(x => x)
        )
      },
      null,
      onProgress
        ? (type, fileIndex, loaded, total) => {
            // calculate progress
            switch (type) {
              case 'done': {
                progress.totalFiles = total
                progress.loadedFiles = loaded
                onProgress({
                  percents: Math.round((progress.loadedSize * 100) / progress.totalSize),
                  totalFiles: progress.totalFiles,
                  loadedFiles: progress.loadedFiles,
                  totalSize: progress.totalSize,
                  loadedSize: progress.loadedSize
                })
                break
              }
              case 'progress': {
                progress.fileLoadedSizes[fileIndex] = loaded
                progress.fileTotalSizes[fileIndex] = total
                progress.totalSize = progress.fileTotalSizes.reduce(
                  (fileSize, totalSize) => (totalSize ? fileSize + totalSize : fileSize),
                  0
                )
                progress.loadedSize = progress.fileLoadedSizes.reduce(
                  (loadedSize, fileLoadedSize) => (fileLoadedSize ? loadedSize + fileLoadedSize : loadedSize),
                  0
                )
                onProgress({
                  percents: Math.round((progress.loadedSize * 100) / progress.totalSize),
                  totalFiles: progress.totalFiles,
                  loadedFiles: progress.loadedFiles,
                  totalSize: progress.totalSize,
                  loadedSize: progress.loadedSize
                })
                break
              }
              default: {
                break
              }
            }
          }
        : null
    )
  })
}
